import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonWithLoading } from './ButtonWithLoading';

// eslint-disable-next-line @typescript-eslint/no-shadow
export const ButtonDelete = forwardRef(function ButtonDelete(props, ref) {
  const {
    t
  } = useTranslation('common');
  return <ButtonWithLoading ref={ref} color="error" {...props} data-testid="button-delete">
			{props.children || t('buttons.delete')}
		</ButtonWithLoading>;
});